import React from 'react';
import './ConfirmationModal.css'; // Make sure this CSS file exists

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <p className="modal-message">{message}</p>
                <div className="modal-buttons">
                    <button onClick={onCancel} className="btn-secondary">Cancel</button>
                    {/* ✅ MODIFICATION: Changed className to make the button blue */}
                    <button onClick={onConfirm} className="btn-primary">Confirm</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;   